@import './styles/lists';
@import './styles/paragraph';
@import './styles/prosemirror';
@import './styles/code';
@import './styles/comment';
@import './styles/headers';

.editorRenderer {
  height: 100%;

  :global(.ProseMirror) {
    outline: none;
    height: 100%;
    padding-bottom: 30vh;
  }

  @for $i from 0 through $list-max-depth {
    [data-depth='#{$i}'] {
      --indent-padding: calc(#{$i} * 30px);
    }
  }

  [data-alignment='center'] {
    text-align: center;
  }

  [data-alignment='justify'] {
    text-align: justify;
  }

  [data-alignment='left'] {
    text-align: left;
  }

  [data-alignment='right'] {
    text-align: right;
  }

  ::selection {
    background-color: var(--text-selection-highlight);
  }

  :global(.aiSelection) {
    background: rgba(102, 78, 255, 0.1);
  }

  :global(.selectionMarker) {
    background: var(--focus-10);
  }

  ::selection {
    background-color: var(--focus-10);
  }

  &:not(:focus-within) {
    ::selection {
      background-color: var(--focus-10);
    }

    :global(.selectionMarker) {
      background-color: var(--focus-10);

      &::selection,
      ::selection {
        background-color: transparent;
      }

      &:global(.aiSelection) {
        background: rgba(102, 78, 255, 0.1);
      }
    }
  }

  // fix for EDI-780 (gradient color on an italic text in slanted fonts gets cut off)
  [data-color^='linear-gradient'] {
    padding-right: 0.1ch;
    > [style$='Caveat'] {
      padding-right: 0.3ch;
    }
  }
}

/* stylelint-disable css-modules/no-global-scoped-selector */
:global(.prosemirror-preview) {
  :global(.ProseMirror) {
    padding-bottom: 0;
  }
}
/* stylelint-enable css-modules/no-global-scoped-selector */
